import { createUseStyles } from '@glu/theming';

function getMaxOpenLinks({ navLinks }) {
  if (!navLinks) return 0;
  return Math.max(...navLinks.map(l => getMaxOpenLinks(l))) + navLinks.length;
}

export default createUseStyles(({
  nav: {
    activeHighlightColor,
    link,
    subLink,
    linkDivided,
    outline
  }
}) => ({
  root: {
    fontSize: 18,
    position: 'relative',
    width: '100%'
  },

  lastChildTier: {},

  rootOpen: {
    paddingBottom: ({ openedLinkPaddingBottom }) => openedLinkPaddingBottom,
    '&:last-child': {
      paddingBottom: 0
    },
    '&$lastChildTier': {
      '&:last-child': {
        paddingBottom: ({ openedLinkPaddingBottom }) => openedLinkPaddingBottom
      }
    },
    '&::before': {
      backgroundColor: activeHighlightColor,
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: 10
    }
  },

  rootActive: {
    '&::before': {
      backgroundColor: activeHighlightColor,
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: 10
    }
  },

  icon: {
    backgroundColor: 'transparent',
    border: 'none',
    display: 'flex',
    height: link.icon.height,
    width: link.icon.width,
    marginLeft: 'auto',
    padding: 0,

    '& svg': {
      height: link.icon.height,
      width: link.icon.width,
      fill: subLink.color
    }
  },

  subLinkIcon: {
    height: subLink.icon.height,
    width: subLink.icon.width,
    '& svg': {
      height: subLink.icon.height,
      width: subLink.icon.width,
      fill: subLink.color
    }
  },

  link: {
    alignItems: 'center',
    background: link.background,
    border: 'none',
    boxSizing: 'border-box',
    color: link.color,
    cursor: 'pointer',
    display: 'flex',
    fill: link.color,
    fontFamily: link.fontFamily,
    fontSize: link.fontSize,
    fontWeight: link.fontWeight,
    lineHeight: link.lineHeight,
    marginLeft: 10,
    overflow: 'hidden',
    padding: link.padding,
    textDecoration: 'none',
    width: 'calc(100% - 10px)',
    whiteSpace: 'nowrap',

    '&:hover, &:focus': {
      textDecoration: 'none',
      '&::before': {
        backgroundColor: activeHighlightColor,
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: 10
      }
    },

    '&:focus': {
      outline: {
        width: outline.width,
        style: outline.style,
        color: outline.color
      }
    },
    '&:disabled': {
      opacity: link.disabledOpacity
    }
  },

  hasIcon: {},

  linkTier1: {
    '&$hasIcon': {
      marginLeft: 40,
      width: 'calc(100% - 50px)'
    },
    fontFamily: subLink.fontFamily,
    fontSize: subLink.fontSize,
    fontWeight: subLink.fontWeight,
    lineHeight: subLink.lineHeight,
    padding: subLink.padding,
    marginLeft: 27,
    width: 'calc(100% - 37px)',

    '&:hover, &:focus': {
      background: subLink.hoverColor
    }
  },

  linkTier2: {
    '&$hasIcon': {
      marginLeft: 53,
      width: 'calc(100% - 63px)'
    },
    fontFamily: subLink.fontFamily,
    fontSize: subLink.fontSize,
    fontWeight: subLink.fontWeight,
    lineHeight: subLink.lineHeight,
    padding: subLink.padding,
    marginLeft: 40,
    width: 'calc(100% - 50px)',

    '&:hover, &:focus': {
      background: subLink.hoverColor
    }
  },

  linkDivided: {
    borderTop: {
      style: linkDivided.style,
      width: linkDivided.width,
      color: linkDivided.color
    }
  },

  textLink: {
    marginBottom: 0,

    '&:hover': {
      backgroundColor: 'transparent'
    }
  },

  active: {
    textDecoration: 'none'
  },

  navLinks: {
    listStyle: 'none',
    padding: [outline.width, 0],
    maxHeight: 0,
    opacity: 0,
    overflow: 'hidden',
    transition: 'max-height 0.5s ease-in-out, opacity 0.5s ease-in-out, visibility 0.5s',
    visibility: 'hidden',

    '& $rootActive a': {
      background: subLink.hoverColor
    }
  },

  openLinks: {
    maxHeight: ({ openedLinkPaddingBottom, navLinks }) => {
      const openLinksCount = getMaxOpenLinks({ navLinks });
      const linkHeight = Number.parseFloat(subLink.lineHeight);
      return ((openLinksCount * linkHeight)
        + (openLinksCount ? (openedLinkPaddingBottom + (outline.width * 2)) : 0));
    },
    opacity: 1,
    visibility: 'visible'
  }
}));
